import React from 'react'
import View from '../../../View/components/View'
import { config } from '../../../../config/Structure'
import styled from 'styled-components'

const SubTypes = () => {
  return (
    <div>
      <TableHolder>
      <View componentName='subTypes' config={config.subTypes} />

      </TableHolder>
    </div>
  )
}

export default SubTypes



const TableHolder  = styled.div`
@media (max-width:767px){

  td:nth-child(3), td:nth-child(4) {
    display: inline-block;
    text-align: center;
  }
}

`